/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { CmTeasable_CmArticleImpl_Fragment, CmTeasable_CmAudioImpl_Fragment, CmTeasable_CmChannelImpl_Fragment, CmTeasable_CmCollectionImpl_Fragment, CmTeasable_CmDownloadImpl_Fragment, CmTeasable_CmDynamicListImpl_Fragment, CmTeasable_CmExternalLinkImpl_Fragment, CmTeasable_CmGalleryImpl_Fragment, CmTeasable_CmhtmlImpl_Fragment, CmTeasable_CmImageMapImpl_Fragment, CmTeasable_CmInteractiveImpl_Fragment, CmTeasable_CmLocTaxonomyImpl_Fragment, CmTeasable_CmMediaImpl_Fragment, CmTeasable_CmNavigationImpl_Fragment, CmTeasable_CmPersonImpl_Fragment, CmTeasable_CmPictureImpl_Fragment, CmTeasable_CmPlaceholderImpl_Fragment, CmTeasable_CmProductImpl_Fragment, CmTeasable_CmQueryListImpl_Fragment, CmTeasable_CmSelectionRulesImpl_Fragment, CmTeasable_CmSpinnerImpl_Fragment, CmTeasable_CmTaxonomyImpl_Fragment, CmTeasable_CmTeasableImpl_Fragment, CmTeasable_CmTeaserImpl_Fragment, CmTeasable_CmVideoImpl_Fragment, CmTeasable_CmVisualImpl_Fragment, CmTeasable_FormEditorImpl_Fragment, CmTeasable_SosAmountIncreaseFormImpl_Fragment, CmTeasable_SosAuthorImpl_Fragment, CmTeasable_SosChartImpl_Fragment, CmTeasable_SosContactImpl_Fragment, CmTeasable_SosDonationCardImpl_Fragment, CmTeasable_SosDonationCertificateImpl_Fragment, CmTeasable_SosDonationFormImpl_Fragment, CmTeasable_SosDonationProductImpl_Fragment, CmTeasable_SosDonationProgressImpl_Fragment, CmTeasable_SosDonationToolImpl_Fragment, CmTeasable_SosEventImpl_Fragment, CmTeasable_SosFilterTeaserImpl_Fragment, CmTeasable_SosInternalLinkImpl_Fragment, CmTeasable_SosJobTeaserImpl_Fragment, CmTeasable_SosLocationImpl_Fragment, CmTeasable_SosNewsImpl_Fragment, CmTeasable_SosNotificationImpl_Fragment, CmTeasable_SosOfferImpl_Fragment, CmTeasable_SosOrderFormImpl_Fragment, CmTeasable_SosOrganisationImpl_Fragment, CmTeasable_SosOverlayImpl_Fragment, CmTeasable_SosPressreleaseImpl_Fragment, CmTeasable_SosPublicationImpl_Fragment, CmTeasable_SosRedirectPageImpl_Fragment, CmTeasable_SosSpecialTopicCategoryImpl_Fragment, CmTeasable_SosSpecialTopicImpl_Fragment, CmTeasable_SosTeaserImpl_Fragment, CmTeasable_SosTextfragmentImpl_Fragment, CmTeasable_SosTooltipImpl_Fragment, CmTeasable_SosWimmelbildImpl_Fragment, CmTeasable_ViewTypeHeroCollection_Fragment } from './CMTeasable.fragment';
import { CmDownloadFragment } from './CMDownload.fragment';
import { CmExternalLinkFragment } from './CMExternalLink.fragment';
import { CmImageMapFragment } from './CMImageMap.fragment';
import { CmCollection2_CmCollectionImpl_Fragment, CmCollection2_CmDynamicListImpl_Fragment, CmCollection2_CmGalleryImpl_Fragment, CmCollection2_CmQueryListImpl_Fragment, CmCollection2_CmSelectionRulesImpl_Fragment, CmCollection2_ViewTypeHeroCollection_Fragment } from './CMCollection2.fragment';
import { CmhtmlFragment } from './CMHtml.fragment';
import { SosTextfragmentFragment } from './SOSTextfragment.fragment';
import { SosTeaserFragment } from './SOSTeaser.fragment';
import { SosDonationCardFragment } from './SOSDonationCard.fragment';
import { SosFilterTeaserFragment } from './SOSFilterTeaser.fragment';
import { gql } from '@apollo/client';
import { CmTeasableFragmentDoc } from './CMTeasable.fragment';
import { CmDownloadFragmentDoc } from './CMDownload.fragment';
import { CmExternalLinkFragmentDoc } from './CMExternalLink.fragment';
import { CmImageMapFragmentDoc } from './CMImageMap.fragment';
import { CmCollection2FragmentDoc } from './CMCollection2.fragment';
import { CmhtmlFragmentDoc } from './CMHtml.fragment';
import { SosTextfragmentFragmentDoc } from './SOSTextfragment.fragment';
import { SosTeaserFragmentDoc } from './SOSTeaser.fragment';
import { SosDonationCardFragmentDoc } from './SOSDonationCard.fragment';
import { SosFilterTeaserFragmentDoc } from './SOSFilterTeaser.fragment';
export type CmCollection_CmCollectionImpl_Fragment = (
  { __typename?: 'CMCollectionImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
    & CmImageMapFragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasable_CmCollectionImpl_Fragment
);

export type CmCollection_CmDynamicListImpl_Fragment = (
  { __typename?: 'CMDynamicListImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
    & CmImageMapFragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasable_CmDynamicListImpl_Fragment
);

export type CmCollection_CmGalleryImpl_Fragment = (
  { __typename?: 'CMGalleryImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
    & CmImageMapFragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasable_CmGalleryImpl_Fragment
);

export type CmCollection_CmQueryListImpl_Fragment = (
  { __typename?: 'CMQueryListImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
    & CmImageMapFragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasable_CmQueryListImpl_Fragment
);

export type CmCollection_CmSelectionRulesImpl_Fragment = (
  { __typename?: 'CMSelectionRulesImpl', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
    & CmImageMapFragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasable_CmSelectionRulesImpl_Fragment
);

export type CmCollection_ViewTypeHeroCollection_Fragment = (
  { __typename?: 'ViewTypeHeroCollection', viewtype?: string | null, callToActionSettings?: any | null, downloadSettings?: any | null, teaserCarouselSettings?: any | null, queryListSettings?: any | null, subjectTeaserSettings?: any | null, accordionSettings?: any | null, c016GlobalFilterSettings?: any | null, items?: Array<(
    { __typename?: 'CMArticleImpl' }
    & CmTeasable_CmArticleImpl_Fragment
  ) | (
    { __typename?: 'CMAudioImpl' }
    & CmTeasable_CmAudioImpl_Fragment
  ) | (
    { __typename?: 'CMChannelImpl' }
    & CmTeasable_CmChannelImpl_Fragment
  ) | (
    { __typename?: 'CMCollectionImpl' }
    & CmTeasable_CmCollectionImpl_Fragment
    & CmCollection2_CmCollectionImpl_Fragment
  ) | (
    { __typename?: 'CMDownloadImpl' }
    & CmTeasable_CmDownloadImpl_Fragment
    & CmDownloadFragment
  ) | (
    { __typename?: 'CMDynamicListImpl' }
    & CmTeasable_CmDynamicListImpl_Fragment
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | (
    { __typename?: 'CMExternalLinkImpl' }
    & CmTeasable_CmExternalLinkImpl_Fragment
    & CmExternalLinkFragment
  ) | (
    { __typename?: 'CMGalleryImpl' }
    & CmTeasable_CmGalleryImpl_Fragment
    & CmCollection2_CmGalleryImpl_Fragment
  ) | (
    { __typename?: 'CMHTMLImpl' }
    & CmTeasable_CmhtmlImpl_Fragment
    & CmhtmlFragment
  ) | (
    { __typename?: 'CMImageMapImpl' }
    & CmTeasable_CmImageMapImpl_Fragment
    & CmImageMapFragment
  ) | (
    { __typename?: 'CMInteractiveImpl' }
    & CmTeasable_CmInteractiveImpl_Fragment
  ) | { __typename?: 'CMLinkableImpl' } | (
    { __typename?: 'CMLocTaxonomyImpl' }
    & CmTeasable_CmLocTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMMediaImpl' }
    & CmTeasable_CmMediaImpl_Fragment
  ) | (
    { __typename?: 'CMNavigationImpl' }
    & CmTeasable_CmNavigationImpl_Fragment
  ) | (
    { __typename?: 'CMPersonImpl' }
    & CmTeasable_CmPersonImpl_Fragment
  ) | (
    { __typename?: 'CMPictureImpl' }
    & CmTeasable_CmPictureImpl_Fragment
  ) | (
    { __typename?: 'CMPlaceholderImpl' }
    & CmTeasable_CmPlaceholderImpl_Fragment
  ) | (
    { __typename?: 'CMProductImpl' }
    & CmTeasable_CmProductImpl_Fragment
  ) | (
    { __typename?: 'CMQueryListImpl' }
    & CmTeasable_CmQueryListImpl_Fragment
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmTeasable_CmSelectionRulesImpl_Fragment
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | (
    { __typename?: 'CMSpinnerImpl' }
    & CmTeasable_CmSpinnerImpl_Fragment
  ) | (
    { __typename?: 'CMTaxonomyImpl' }
    & CmTeasable_CmTaxonomyImpl_Fragment
  ) | (
    { __typename?: 'CMTeasableImpl' }
    & CmTeasable_CmTeasableImpl_Fragment
  ) | (
    { __typename?: 'CMTeaserImpl' }
    & CmTeasable_CmTeaserImpl_Fragment
  ) | (
    { __typename?: 'CMVideoImpl' }
    & CmTeasable_CmVideoImpl_Fragment
  ) | (
    { __typename?: 'CMVisualImpl' }
    & CmTeasable_CmVisualImpl_Fragment
  ) | (
    { __typename?: 'FormEditorImpl' }
    & CmTeasable_FormEditorImpl_Fragment
  ) | (
    { __typename?: 'SOSAmountIncreaseFormImpl' }
    & CmTeasable_SosAmountIncreaseFormImpl_Fragment
  ) | (
    { __typename?: 'SOSAuthorImpl' }
    & CmTeasable_SosAuthorImpl_Fragment
  ) | (
    { __typename?: 'SOSChartImpl' }
    & CmTeasable_SosChartImpl_Fragment
  ) | (
    { __typename?: 'SOSContactImpl' }
    & CmTeasable_SosContactImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationCardImpl' }
    & CmTeasable_SosDonationCardImpl_Fragment
    & SosDonationCardFragment
  ) | (
    { __typename?: 'SOSDonationCertificateImpl' }
    & CmTeasable_SosDonationCertificateImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationFormImpl' }
    & CmTeasable_SosDonationFormImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProductImpl' }
    & CmTeasable_SosDonationProductImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationProgressImpl' }
    & CmTeasable_SosDonationProgressImpl_Fragment
  ) | (
    { __typename?: 'SOSDonationToolImpl' }
    & CmTeasable_SosDonationToolImpl_Fragment
  ) | (
    { __typename?: 'SOSEventImpl' }
    & CmTeasable_SosEventImpl_Fragment
  ) | (
    { __typename?: 'SOSFilterTeaserImpl' }
    & CmTeasable_SosFilterTeaserImpl_Fragment
    & SosFilterTeaserFragment
  ) | (
    { __typename?: 'SOSInternalLinkImpl' }
    & CmTeasable_SosInternalLinkImpl_Fragment
  ) | (
    { __typename?: 'SOSJobTeaserImpl' }
    & CmTeasable_SosJobTeaserImpl_Fragment
  ) | (
    { __typename?: 'SOSLocationImpl' }
    & CmTeasable_SosLocationImpl_Fragment
  ) | (
    { __typename?: 'SOSNewsImpl' }
    & CmTeasable_SosNewsImpl_Fragment
  ) | (
    { __typename?: 'SOSNotificationImpl' }
    & CmTeasable_SosNotificationImpl_Fragment
  ) | (
    { __typename?: 'SOSOfferImpl' }
    & CmTeasable_SosOfferImpl_Fragment
  ) | (
    { __typename?: 'SOSOrderFormImpl' }
    & CmTeasable_SosOrderFormImpl_Fragment
  ) | (
    { __typename?: 'SOSOrganisationImpl' }
    & CmTeasable_SosOrganisationImpl_Fragment
  ) | (
    { __typename?: 'SOSOverlayImpl' }
    & CmTeasable_SosOverlayImpl_Fragment
  ) | (
    { __typename?: 'SOSPressreleaseImpl' }
    & CmTeasable_SosPressreleaseImpl_Fragment
  ) | (
    { __typename?: 'SOSPublicationImpl' }
    & CmTeasable_SosPublicationImpl_Fragment
  ) | (
    { __typename?: 'SOSRedirectPageImpl' }
    & CmTeasable_SosRedirectPageImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicCategoryImpl' }
    & CmTeasable_SosSpecialTopicCategoryImpl_Fragment
  ) | (
    { __typename?: 'SOSSpecialTopicImpl' }
    & CmTeasable_SosSpecialTopicImpl_Fragment
  ) | (
    { __typename?: 'SOSTeaserImpl' }
    & CmTeasable_SosTeaserImpl_Fragment
    & SosTeaserFragment
  ) | (
    { __typename?: 'SOSTextfragmentImpl' }
    & CmTeasable_SosTextfragmentImpl_Fragment
    & SosTextfragmentFragment
  ) | (
    { __typename?: 'SOSTooltipImpl' }
    & CmTeasable_SosTooltipImpl_Fragment
  ) | (
    { __typename?: 'SOSWimmelbildImpl' }
    & CmTeasable_SosWimmelbildImpl_Fragment
  ) | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmTeasable_ViewTypeHeroCollection_Fragment
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null, teasableItems?: Array<{ __typename?: 'CMArticleImpl' } | { __typename?: 'CMAudioImpl' } | { __typename?: 'CMChannelImpl' } | (
    { __typename?: 'CMCollectionImpl' }
    & CmCollection2_CmCollectionImpl_Fragment
  ) | { __typename?: 'CMDownloadImpl' } | (
    { __typename?: 'CMDynamicListImpl' }
    & CmCollection2_CmDynamicListImpl_Fragment
  ) | { __typename?: 'CMExternalLinkImpl' } | (
    { __typename?: 'CMGalleryImpl' }
    & CmCollection2_CmGalleryImpl_Fragment
  ) | { __typename?: 'CMHTMLImpl' } | { __typename?: 'CMImageMapImpl' } | { __typename?: 'CMInteractiveImpl' } | { __typename?: 'CMLocTaxonomyImpl' } | { __typename?: 'CMMediaImpl' } | { __typename?: 'CMNavigationImpl' } | { __typename?: 'CMPersonImpl' } | { __typename?: 'CMPictureImpl' } | { __typename?: 'CMPlaceholderImpl' } | { __typename?: 'CMProductImpl' } | (
    { __typename?: 'CMQueryListImpl' }
    & CmCollection2_CmQueryListImpl_Fragment
  ) | (
    { __typename?: 'CMSelectionRulesImpl' }
    & CmCollection2_CmSelectionRulesImpl_Fragment
  ) | { __typename?: 'CMSpinnerImpl' } | { __typename?: 'CMTaxonomyImpl' } | { __typename?: 'CMTeasableImpl' } | { __typename?: 'CMTeaserImpl' } | { __typename?: 'CMVideoImpl' } | { __typename?: 'CMVisualImpl' } | { __typename?: 'FormEditorImpl' } | { __typename?: 'SOSAmountIncreaseFormImpl' } | { __typename?: 'SOSAuthorImpl' } | { __typename?: 'SOSChartImpl' } | { __typename?: 'SOSContactImpl' } | { __typename?: 'SOSDonationCardImpl' } | { __typename?: 'SOSDonationCertificateImpl' } | { __typename?: 'SOSDonationFormImpl' } | { __typename?: 'SOSDonationProductImpl' } | { __typename?: 'SOSDonationProgressImpl' } | { __typename?: 'SOSDonationToolImpl' } | { __typename?: 'SOSEventImpl' } | { __typename?: 'SOSFilterTeaserImpl' } | { __typename?: 'SOSInternalLinkImpl' } | { __typename?: 'SOSJobTeaserImpl' } | { __typename?: 'SOSLocationImpl' } | { __typename?: 'SOSNewsImpl' } | { __typename?: 'SOSNotificationImpl' } | { __typename?: 'SOSOfferImpl' } | { __typename?: 'SOSOrderFormImpl' } | { __typename?: 'SOSOrganisationImpl' } | { __typename?: 'SOSOverlayImpl' } | { __typename?: 'SOSPressreleaseImpl' } | { __typename?: 'SOSPublicationImpl' } | { __typename?: 'SOSRedirectPageImpl' } | { __typename?: 'SOSSpecialTopicCategoryImpl' } | { __typename?: 'SOSSpecialTopicImpl' } | { __typename?: 'SOSTeaserImpl' } | { __typename?: 'SOSTextfragmentImpl' } | { __typename?: 'SOSTooltipImpl' } | { __typename?: 'SOSWimmelbildImpl' } | (
    { __typename?: 'ViewTypeHeroCollection' }
    & CmCollection2_ViewTypeHeroCollection_Fragment
  ) | null> | null }
  & CmTeasable_ViewTypeHeroCollection_Fragment
);

export type CmCollectionFragment = CmCollection_CmCollectionImpl_Fragment | CmCollection_CmDynamicListImpl_Fragment | CmCollection_CmGalleryImpl_Fragment | CmCollection_CmQueryListImpl_Fragment | CmCollection_CmSelectionRulesImpl_Fragment | CmCollection_ViewTypeHeroCollection_Fragment;

export const CmCollectionFragmentDoc = gql`
    fragment CMCollection on CMCollection {
  ...CMTeasable
  viewtype
  items {
    ...CMTeasable
    ...CMImageMap
    ...CMExternalLink
    ...CMDownload
    ...CMCollection2
    ...SOSTeaser
    ...SOSFilterTeaser
    ...CMHTML
    ...SOSTextfragment
    ...SOSDonationCard
  }
  teasableItems {
    ...CMCollection2
  }
  callToActionSettings: settings(
    paths: ["callToActionDisabled", "callToActionCustomText", "callToActionLink"]
  )
  downloadSettings: settings(paths: ["downloadDesktop", "showMoreCount"])
  teaserCarouselSettings: settings(
    paths: ["gallery.autoplay", "gallery.autoplay.speed", "gallery.imageslide.speed"]
  )
  queryListSettings: settings(
    paths: ["limit", "callToActionCustomText", "loadMore", "order"]
  )
  subjectTeaserSettings: settings(
    paths: ["numberTilesDesktop", "numberTilesMobile", "loadMore"]
  )
  accordionSettings: settings(paths: ["accordionOpen"])
  c016GlobalFilterSettings: settings(
    paths: ["numberTilesDesktop", "numberTilesMobile", "callToActionCustomText", "showMoreCount", "teaser.max.length"]
  )
}
    ${CmTeasableFragmentDoc}
${CmImageMapFragmentDoc}
${CmExternalLinkFragmentDoc}
${CmDownloadFragmentDoc}
${CmCollection2FragmentDoc}
${SosTeaserFragmentDoc}
${SosFilterTeaserFragmentDoc}
${CmhtmlFragmentDoc}
${SosTextfragmentFragmentDoc}
${SosDonationCardFragmentDoc}`;